export default __webpack_public_path__ + "assets/images/back-icon.c733a880bd6d3d1f0f38ef1608fb8a32.png";